var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { stroke: "currentColor", strokeWidth: 2, x: 12, y: 12, width: 24, height: 24, rx: 3 }),
            React.createElement("path", { d: "M24.883 14.968l1.325 2.422a1 1 0 01-.877 1.48h-2.64a1 1 0 01-.88-1.477l1.316-2.423a1 1 0 011.756-.002zM24.883 33.016l1.323-2.413a1 1 0 00-.877-1.48h-2.636a1 1 0 00-.878 1.478l1.313 2.412a1 1 0 001.755.003zM32.996 23.12L30.59 21.8a1 1 0 00-1.481.876v2.634a1 1 0 001.478.878l2.407-1.312a1 1 0 00.002-1.755zM14.988 23.12l2.398-1.319a1 1 0 011.482.876v2.63a1 1 0 01-1.48.878l-2.397-1.31a1 1 0 01-.003-1.754z", fill: "currentColor" }))));
});
